/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './icd-details.reducer';

export const IcdDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const icdDetailsEntity = useAppSelector(state => state.icdDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="icdDetailsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.icdDetails.detail.title">IcdDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.icdDetails.id">Id</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.id}</dd>
          <dt>
            <span id="icd9Code">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icd9Code">Icd 9 Code</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icd9Code}</dd>
          <dt>
            <span id="icd10Code">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icd10Code">Icd 10 Code</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icd10Code}</dd>
          <dt>
            <span id="icd9Descrip">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icd9Descrip">Icd 9 Descrip</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icd9Descrip}</dd>
          <dt>
            <span id="icd10Descrip">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icd10Descrip">Icd 10 Descrip</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icd10Descrip}</dd>
          <dt>
            <span id="icdmetadesc">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icdmetadesc">Icdmetadesc</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icdmetadesc}</dd>
          <dt>
            <span id="icdng">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icdng">Icdng</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icdng}</dd>
          <dt>
            <span id="icddrg">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icddrg">Icddrg</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icddrg}</dd>
          <dt>
            <span id="icdnum">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icdnum">Icdnum</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icdnum}</dd>
          <dt>
            <span id="icdamt">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icdamt">Icdamt</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icdamt}</dd>
          <dt>
            <span id="icdcoll">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icdcoll">Icdcoll</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icdcoll}</dd>
          <dt>
            <span id="icdarchive">
              <Translate contentKey="tinyMedicRestApp.icdDetails.icdarchive">Icdarchive</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.icdarchive}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.icdDetails.active">Active</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.icdDetails.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.icdDetails.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.icdDetails.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.icdDetails.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{icdDetailsEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/icd-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/icd-details/${icdDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IcdDetailsDetail;
